import { useEffect, useState } from 'react';

import { SHOffer, useSortingHat } from '@libs/creditkit';

import { useUserContext } from '@common/contexts/UserContext';
import { useTracking } from '@common/hooks/useTracking';
import { ModalDataEventProp } from '@common/hooks/useTracking/types';

export const useHubModal = () => {
  const { user, getTokens } = useUserContext();
	const { accessToken } = getTokens();
  const { elementClickedEvent, modalViewedEvent } = useTracking();
  const { shDecisionList } = useSortingHat({ user, accessToken });

  const [offers, setOffers] = useState<SHOffer[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  const locationName = 'popup-ofertas';

  const username = user?.full_name.split(' ')[0] || null;
  const title = username ? `${username}, temos ofertas selecionadas para você` : 'Temos ofertas selecionadas para você';

  useEffect(() => {
    const hasOffer = shDecisionList && shDecisionList.length > 0;
    const modalHasDisplayed = sessionStorage.getItem('offers_modal_displayed');

    if (hasOffer) {
      if (!firstRender || modalHasDisplayed) return;
      setFirstRender(false);
      mountComponent(shDecisionList);
    }
  }, [shDecisionList, firstRender]);

  function mountComponent(offerList: SHOffer[]) {
    const twoFirstOffers = offerList.slice(0, 2);
    setOffers(twoFirstOffers);
    const modalData = twoFirstOffers.map(
      (offer) =>
        ({
          cardSlug: offer.generalInfo.slug,
          partner: offer.generalInfo.partner,
        } as ModalDataEventProp)
    );

    setShowModal(true);
    modalViewedEvent({ modalData, location: locationName });

    sessionStorage.setItem('offers_modal_displayed', 'true');
  }

  function handleClose() {
    elementClickedEvent({
      elementType: 'close',
      location: window.location.pathname,
      name: `${locationName} - Close`,
    });
    setShowModal(false);
  }

  return { offers, showModal, handleClose, title };
};